import { PageLink } from '../../../../../../../assets/layout/core'

export const breadcrumbView: PageLink[] = [
  {
    title: 'Ips Permitidos',
    path: '/users/ipAlloweds',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
